import { createContext, useContext } from "react";

export const PrivateContext = createContext(false);

// True inside a Private ancestor. Portaled content (tooltips, popovers) leaves
// the data-private DOM subtree, so it uses this to redact itself.
export const useIsPrivate = () => useContext(PrivateContext);
